




import { observable, action, computed, autorun } from 'mobx';
import { isMobile } from 'react-device-detect';
import { getIDs } from '../components/Matrix/functions/getID';
import { IOrgStageCoordsGetterOutput } from '../components/Matrix/functions/getOrgStages-1';
import { constants } from '../Constants';
import { RootStore } from './RootStore';





export class DimensionsStore {

    rootStore = RootStore;
    constructor(rootStore: any) {
        this.rootStore = rootStore

        autorun(() => {

            window.addEventListener('resize', () => {

                let {width, height} = getScreenDimensions()

                this.WIDTH_SCREEN = width;
                this.HEIGHT_SCREEN = height 
            })

        })

    }



    @observable WIDTH_SCREEN = getScreenDimensions().width
    @observable HEIGHT_SCREEN = getScreenDimensions().height
    


    @computed get WIDTH_MATRIX(){
        return this.WIDTH_SCREEN - this.WIDTH_SIDEBAR
    }

    @computed get WIDTH_SIDEBAR(){
        return this.WIDTH_SCREEN * 0.3
    }

    @computed get WIDTH_STRUCTURE(){
        return this.WIDTH_MATRIX - 20
    }

    
    


    // HEIGHT

   

    @computed get HEIGHT_SIDEBAR(){
        return this.HEIGHT_SCREEN
    }


    @computed get HEIGHT_MATRIX_AREA(){
        console.log('HEIGHT_MATRIX_AREA', this.HEIGHT_SCREEN)
        return this.HEIGHT_SCREEN
    }


    @computed get HEIGHT_MATRIX_CONTAINER(){
        let height = 19 * (constants.BLOCK.HEIGHT + 3.8);
        console.log('HEIGHT_MATRIX_CONTAINER', height)
        return height
    }

    @computed get HEIGHT_STRUCTURE(){
 
        let offset = 0.5 * (this.HEIGHT_SCREEN - this.HEIGHT_MATRIX_CONTAINER - 145)
        console.log('offset', offset)
        console.log('HEIGHT STRUCTURE', this.HEIGHT_SCREEN - offset)
        let height = this.HEIGHT_MATRIX_CONTAINER + offset;
        return isMobile ? this.WIDTH_SCREEN * 0.5 : height
    }


}















export type D = {
    width: number,
    height: number
}

export const getScreenDimensions = (): D => {
    const width = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

    const height = window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;

    return { width, height }
}